'use client';

import type { ReactNode } from 'react';

export function Accordion({
  id,
  title,
  open,
  onToggle,
  actions,
  children,
  className,
}: {
  id: string;
  title: ReactNode;
  open: boolean;
  onToggle: () => void;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={`mx-accordion${className ? ` ${className}` : ''}`} data-open={open ? 'true' : 'false'}>
      <div className="mx-accordion__head">
        <button
          type="button"
          className="mx-accordion__toggle"
          aria-expanded={open}
          aria-controls={id}
          onClick={onToggle}
        >
          <span className="mx-accordion__title">{title}</span>
          <span className="mx-accordion__chevron" aria-hidden="true">▼</span>
        </button>
        {actions != null && <div className="mx-accordion__actions">{actions}</div>}
      </div>
      <div id={id} className="mx-accordion__body" hidden={!open}>
        {children}
      </div>
    </div>
  );
}
